// Utility function to map category IDs to proper display names
export const getCategoryDisplayName = (categoryId) => {
  const categoryMap = {
    'zacece': 'Začeće',
    'trudnoca': 'Trudnoća',
    'porodjaj': 'Porođaj',
    'zivot-sa-bebom': 'Život sa bebom'
  };
  return categoryMap[categoryId] || categoryId;
}; 